import { __assign, __awaiter, __generator } from "tslib";
import { app } from '@ekuaibao/whispered';
import { flatten } from 'lodash';
import { standardValueMoney } from './misc';
import { enableOtherInvoiceByDimension } from './featbit/feat-switch';
import Big from 'big.js';
import { calculateAble } from '../components/utils/fnCurrencyObj';
export function updateInvoiceDeduction(feetypes, invoiceList, isMerge) {
    var _a, _b, _c;
    if (feetypes === void 0) { feetypes = []; }
    if (invoiceList === void 0) { invoiceList = []; }
    if (isMerge === void 0) { isMerge = false; }
    return __awaiter(this, void 0, Promise, function () {
        var isUpdate, params, invoiceIds, appInstance, value, invoiceData;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    isUpdate = false;
                    params = feetypes.map(function (feeType, index) {
                        var invoices = isMerge ? invoiceList : [invoiceList[index]];
                        var invoiceIds = invoices
                            .map(function (invoice) {
                            var _a, _b;
                            return { masterId: (_a = invoice.master) === null || _a === void 0 ? void 0 : _a.id, detailIds: (_b = invoice === null || invoice === void 0 ? void 0 : invoice.details) === null || _b === void 0 ? void 0 : _b.map(function (detail) { return detail === null || detail === void 0 ? void 0 : detail.id; }) };
                        })
                            .filter(function (invoice) { var _a; return !!((_a = invoice === null || invoice === void 0 ? void 0 : invoice.masterId) === null || _a === void 0 ? void 0 : _a.length); });
                        return { feeTypeId: feeType === null || feeType === void 0 ? void 0 : feeType.id, invoiceIds: invoiceIds };
                    });
                    invoiceIds = params.map(function (param) { return param.invoiceIds; }).filter(function (invoice) { return invoice === null || invoice === void 0 ? void 0 : invoice.length; });
                    if (!invoiceIds.length) {
                        return [2, isUpdate];
                    }
                    appInstance = app;
                    (_a = appInstance === null || appInstance === void 0 ? void 0 : appInstance.logger) === null || _a === void 0 ? void 0 : _a.info('开始价税分离', params);
                    return [4, app.invokeService('@bills:update:invoice:tax', params)];
                case 1:
                    value = _d.sent();
                    (_b = appInstance === null || appInstance === void 0 ? void 0 : appInstance.logger) === null || _b === void 0 ? void 0 : _b.info('价税分离后台返回值', value);
                    if (value && ((_c = Object.keys(value)) === null || _c === void 0 ? void 0 : _c.length)) {
                        isUpdate = true;
                        invoiceData = flatten(invoiceList);
                        invoiceData.forEach(function (invoice) {
                            var _a;
                            var priceSeparated = value[(_a = invoice === null || invoice === void 0 ? void 0 : invoice.master) === null || _a === void 0 ? void 0 : _a.id];
                            if (priceSeparated) {
                                updatePriceSeparatedValue(invoice, priceSeparated);
                            }
                        });
                    }
                    return [2, isUpdate];
            }
        });
    });
}
function updatePriceSeparatedValue(invoice, priceSeparated) {
    var amount = invoice.master.form["E_system_" + invoice.master.entityId + "_\u91D1\u989D"] || invoice.master.form["E_\u7A0E\u989D"];
    if (enableOtherInvoiceByDimension() && (amount === null || amount === void 0 ? void 0 : amount.foreignNumCode) === '156' && calculateAble([amount === null || amount === void 0 ? void 0 : amount.rate, amount === null || amount === void 0 ? void 0 : amount.foreignScale, priceSeparated.taxAmount])) {
        var currency = (app.getState()['@bills'].dimentionCurrencyInfo || {}).currency;
        if ((currency === null || currency === void 0 ? void 0 : currency.numCode) !== '156') {
            var standard = new Big(priceSeparated.taxAmount).times(amount === null || amount === void 0 ? void 0 : amount.rate).toFixed(Number(amount === null || amount === void 0 ? void 0 : amount.foreignScale));
            invoice.taxAmount = __assign(__assign({}, amount), { standard: standard, foreign: priceSeparated.taxAmount });
        }
        else {
            var foreign = new Big(priceSeparated.taxAmount).div(amount === null || amount === void 0 ? void 0 : amount.rate).toFixed(Number(amount === null || amount === void 0 ? void 0 : amount.foreignScale));
            invoice.taxAmount = __assign(__assign({}, amount), { standard: priceSeparated.taxAmount, foreign: foreign });
        }
    }
    else {
        invoice.taxAmount = standardValueMoney(priceSeparated.taxAmount);
    }
    invoice.taxRate = priceSeparated.taxRate;
}
